/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddQuestionDto } from '../models/AddQuestionDto';
import type { CreateTestDto } from '../models/CreateTestDto';
import type { ObjectResponseDto } from '../models/ObjectResponseDto';
import type { UpdateTestDto } from '../models/UpdateTestDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TestsStaffService {
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static testsStaffControllerListPlatform(): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tests/staff/list',
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static testsStaffControllerGetOne({
        id,
    }: {
        id: string,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tests/staff/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static testsStaffControllerUpdate({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: UpdateTestDto,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/tests/staff/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static testsStaffControllerCreate({
        requestBody,
    }: {
        requestBody: CreateTestDto,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tests/staff/new',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static testsStaffControllerAddQuestion({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: AddQuestionDto,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tests/staff/{id}/questions',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static testsStaffControllerUpdateQuestion({
        id,
        qid,
    }: {
        id: string,
        qid: string,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/tests/staff/{id}/questions/{qid}',
            path: {
                'id': id,
                'qid': qid,
            },
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static testsStaffControllerRemoveQuestion({
        id,
        qid,
    }: {
        id: string,
        qid: string,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/tests/staff/{id}/questions/{qid}',
            path: {
                'id': id,
                'qid': qid,
            },
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static testsStaffControllerReorder({
        id,
    }: {
        id: string,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/tests/staff/{id}/reorder',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static testsStaffControllerPublish({
        id,
    }: {
        id: string,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tests/staff/{id}/publish',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static testsStaffControllerArchive({
        id,
    }: {
        id: string,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tests/staff/{id}/archive',
            path: {
                'id': id,
            },
        });
    }
}
